'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _style = require('./style.scss');

var _style2 = _interopRequireDefault(_style);

var _Radio = require('../../../FormInput/Radio');

var _Radio2 = _interopRequireDefault(_Radio);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var string = _react.PropTypes.string,
    shape = _react.PropTypes.shape,
    bool = _react.PropTypes.bool,
    func = _react.PropTypes.func;
var AddressListItem = (_dec = (0, _reactCssModules2.default)(_style2.default), _dec(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(AddressListItem, _React$Component);

  function AddressListItem() {
    (0, _classCallCheck3.default)(this, AddressListItem);
    return (0, _possibleConstructorReturn3.default)(this, (AddressListItem.__proto__ || (0, _getPrototypeOf2.default)(AddressListItem)).apply(this, arguments));
  }

  (0, _createClass3.default)(AddressListItem, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { styleName: 'address-list-item' },
        _react2.default.createElement(
          'div',
          { styleName: 'address-row' },
          _react2.default.createElement(
            'div',
            { styleName: 'column-radio' },
            _react2.default.createElement(_Radio2.default, {
              checked: this.props.selected,
              onChange: this.props.onChange,
              value: this.props.address.id
            })
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'column-address' },
            _react2.default.createElement(
              'ul',
              null,
              _react2.default.createElement(
                'li',
                null,
                this.props.address.firstName,
                ' ',
                this.props.address.lastName
              ),
              _react2.default.createElement(
                'li',
                null,
                this.props.address.company
              ),
              _react2.default.createElement(
                'li',
                null,
                this.props.address.address1
              ),
              _react2.default.createElement(
                'li',
                null,
                this.props.address.address2
              ),
              _react2.default.createElement(
                'li',
                null,
                this.props.address.city
              ),
              _react2.default.createElement(
                'li',
                null,
                this.props.address.state
              ),
              _react2.default.createElement(
                'li',
                null,
                this.props.address.postcode
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'column-options' },
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'li',
              { styleName: 'li-option' },
              _react2.default.createElement(
                'a',
                {
                  href: '#!',
                  styleName: 'column-options__option',
                  onClick: this.props.onEdit
                },
                'Edit'
              )
            ),
            _react2.default.createElement(
              'li',
              { styleName: 'li-option' },
              _react2.default.createElement(
                'a',
                {
                  href: '#!',
                  styleName: 'column-options__option',
                  onClick: this.props.onDelete
                },
                'Delete'
              )
            )
          )
        ),
        _react2.default.createElement('div', { style: { clear: 'both' } })
      );
    }
  }]);
  return AddressListItem;
}(_react2.default.Component), _class2.propTypes = {
  selected: bool.isRequired,
  onEdit: func.isRequired,
  onDelete: func.isRequired,
  onChange: func.isRequired,
  address: shape({
    id: string.isRequired,
    firstName: string.isRequired,
    lastName: string.isRequired,
    company: string.isRequired,
    address1: string.isRequired,
    address2: string.isRequired,
    city: string.isRequired,
    state: string.isRequired,
    postcode: string.isRequired
  })
}, _temp)) || _class);
exports.default = AddressListItem;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/AddressBook/components/AddressListItem/index.js
// module id = 2258
// module chunks = 0